import { useEffect, useState } from "react";
import { useGetOrderbyIdQuery, useEditTracingIdMutation } from "../../Services/OrdersAPI";



function EditTrackId({ id, orderid }) {
    const [trackingId, setTrackingId] = useState("");
    const [trackingUrl, setTrackingUrl] = useState(null);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);

    const [updateCategory, { isLoading }] = useEditTracingIdMutation();
    const { data: categoryDetail, isLoading: loadingContent, error, refetch: refetchCategoryDetail } = useGetOrderbyIdQuery({ id, orderid });


    useEffect(() => {
        refetchCategoryDetail();
    }, [refetchCategoryDetail])

    useEffect(() => {
        setTrackingId(categoryDetail?.order?.track_order_id || "");
        setTrackingUrl(categoryDetail?.order?.order_track_url || "");
    }, [categoryDetail])

    const validateForm = () => {
        let newErrors = {};
        if (!trackingId) newErrors.trackingId = "Tracking ID is required";


        if (!trackingUrl) newErrors.trackingUrl = "Tracking URL is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        let formData = {
            order_id: orderid,
            order_main_id: id,
            order_track_id: trackingId,
            order_track_url: trackingUrl
        }
        try {
            await updateCategory(formData).unwrap();
            alert("Updated successfully!");
            // Reset form fields
            refetchCategoryDetail();
            setErrors({});
            setApiError(null);
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Edit Tracking Details</h3>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        {/* Category Name */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="trackingId" className="form-label">Tracking ID</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="trackingId"
                                    placeholder="Enter Track ID"
                                    value={trackingId}
                                    onChange={(e) => setTrackingId(e.target.value)}
                                />
                                {errors.trackingId && <p className="text-danger">{errors.trackingId}</p>}
                            </div>
                        </div>


                        {/* Description */}
                        <div className="col-md-12 col-sm-12 col-lg-12">
                            <div className="mb-4 text-start">
                                <label htmlFor="tracking_url" className="form-label w-100">Tracking URL</label><br />
                                <input
                                    type="url"
                                    className="form-control"
                                    id="tracking_url"
                                    placeholder="Enter Tracking URL"
                                    value={trackingUrl}
                                    onChange={(e) => setTrackingUrl(e.target.value)}
                                />
                                {errors.trackingUrl && <p className="text-danger">{errors.trackingUrl}</p>}
                            </div>
                        </div>

                    </div>



                    {/* API Error Message */}
                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    {/* Submit Button */}
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default EditTrackId;
